const initAccordion = () =>{
  const accordionSections = document.querySelectorAll('.accordion__section');

  accordionSections.forEach(section => {
    section.addEventListener('click', () => {
      const isCurrent = section.classList.contains('is-current');

      accordionSections.forEach(accordionSection => {
        accordionSection.classList.remove('is-current');
      });

      if (! isCurrent) {
        section.classList.add('is-current');
      }
    });
  });
}


window.addEventListener("DOMContentLoaded", (event)=>{
  initAccordion();
});

window.addEventListener("shopify:section:load", (event)=>{
  initAccordion();
});
